import { CoverManualSettings } from "hoxton-types";

export const ResizeType = {
    Manual: "manual",
    Off: "off",
} as const;

export const CoverType = {
    Manual: "cover",
} as const;

export const HorizontalAlign = {
    Center: "center",
    East: "east",
    West: "west",
} as const;

export const VerticalAlign = {
    Center: "center",
    North: "north",
    South: "south",
} as const;

export function constructCoverUrl({
    imageUrlToResize,
    manualSettings,
    renderService = "",
}: {
    imageUrlToResize: string;
    manualSettings?: CoverManualSettings;
    renderService?: string;
}) {
    if (!manualSettings) {
        return imageUrlToResize;
    }

    const {
        bottomRightCoordinates,
        topLeftCoordinates,
        height,
    }: {
        bottomRightCoordinates: { x: number; y: number };
        topLeftCoordinates: { x: number; y: number };
        height: string;
    } = manualSettings;

    const args = JSON.stringify({
        convertArgs: [
            "-crop",
            `${bottomRightCoordinates.x - topLeftCoordinates.x}x${
                bottomRightCoordinates.y - topLeftCoordinates.y
            }+${topLeftCoordinates.x}+${topLeftCoordinates.y}`,
            "+repage",
            "-resize",
            `x${height}`,
            "+repage",
        ],
        imageUrl: imageUrlToResize,
    });

    const data = typeof btoa === "undefined" ? Buffer.from(args).toString("base64") : btoa(args);

    return `${renderService}/convert?data=${data}`;
}
